// * Bootstrap libraries
import './_bootstrap';

// * Any other global site-wide JavaScript should be placed below.
// begin migrate from citizens_count.script.js into new cc_theme for Drupal 11 Radix 6 upgrade 2025 emn 
(function ($,Drupal) {

  'use strict';

  // // Open top level nav links on second tap
  // Drupal.behaviors.ctzcountNavbar = {
  //   attach: function (context) {
  //     var navbar = $(context).find('nav.navbar');
  //     navbar.once('ctzcount-navbar').each(function () {
  //       $('.dropdown a.dropdown-toggle', $(this)).on('click', function() {
  //         if($(this).parent().hasClass('open'))
  //           location.assign($(this).attr('href'));
  //       });
  //     })
  //   }
  // }

  if (window.location.origin + "/" === window.location.href ) {
    const ctzScroller1 = $(".ctz-scroller-1 .ctz-scroller-content");
    const ctzScroller2 = $(".ctz-scroller-2 .ctz-scroller-content");
    $(window).on("beforeunload", function(e) {
      const newState = {...history.state, scroller1Position: ctzScroller1.scrollTop(), scroller2Position: ctzScroller2.scrollTop()};
      history.replaceState(newState, '', location.href);
    });

    if (history.state != null) {
      if (history.state.scroller1Position != null && history.state.scroller2Position != null) {
        if (typeof history.state.scroller1Position !== 'number' || typeof history.state.scroller2Position !== 'number') return;
        ctzScroller1.scrollTop(history.state.scroller1Position);
        ctzScroller2.scrollTop(history.state.scroller2Position);
        const cleanState = { ...history.state };
        delete cleanState.scroller1Position;
        delete cleanState.scroller2Position;
        history.replaceState(cleanState, '', location.href);
      }
    }
  }

})(jQuery, Drupal);
// end migrate from citizens_count.script.js into new cc_theme for Drupal 11 Radix 6 upgrade 2025 emn 
